import React from 'react';

interface Props { children: React.ReactNode; }
interface State { error: Error | null; }

// Top-level safety net for the whole designer. Before this existed, an
// uncaught render-time error in *any* component (e.g. CartPopup's canvas
// thumbnail generation hitting a lost 2D context — see its own fix) crashed
// the entire React tree with no recovery, since nothing above DesignerApp
// ever caught anything. A reload is the only safe recovery here: the error
// could have left Fabric canvases / Three.js contexts in a half-disposed
// state that local state resets can't reliably undo.
export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Designer crashed:', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', flexDirection: 'column', gap: 12 }}>
          <p style={{ color: '#ef4444', fontSize: 16, fontWeight: 600 }}>Something went wrong</p>
          <p style={{ color: '#64748b', fontSize: 14 }}>{this.state.error.message}</p>
          <button
            onClick={() => window.location.reload()}
            className="btn btn-primary"
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
